import Dropdown from '@common/components/dropdown';
import { useTranslation } from '@common/hooks/translation';
import React from 'react';
import PropTypes from 'prop-types';
import { countryCodes } from './constants';
import './style.scss';

export const CountryFields = ({
  value, onChange, errorMessage,
}) => {
  const t = useTranslation();
  const countryNames = new Set([...countryCodes.map((item) => item.name)]);

  return (
    <div className="country">
      <div className="popup-txt">
        {t('Country')}
      </div>
      <Dropdown
        className="country-select"
        value={value.name}
        onChange={(option) => onChange({
          ...value,
          name: option.value,
        })}
        options={[...countryNames].map((countries) => ({
          value: countries,
          name: countries,
        })) || []}
      />
      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </div>
  );
};

CountryFields.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
};
